import fetchApi from '../../services/fetch';
import { hnAPI } from '../../constants/api';
import { pageURL_HN, texts  , config} from '../../constants'
import { isDisabled, autoCapitalize } from '../../utils/utils';
import {track, updateGlobalTracker,  generateServerResponseError, generateMessageDisplayedSegment} from 'utils/segmenTracker';
import { PHOTO_CAPTURE_COMPLETED, PHOTO_CAPTURE_FAILED, ACTIVATION, CAPTURE_ELEMENT_FRNTID, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED, INELIGIBILITY_NOTIFIED } from 'constants/segmentEvents'

const initialState = {
  ocrError: false,
  validation: {},
  noOcrDetails: {}
};

export const idDetails = {
  state: { ...initialState },
  reducers: {
    updateOCRError(state, payload) {
      return {
        ...state,
        ocrError: payload,
      };
    },
    updateUploadDetails(state, payload) {
      return {
        ...state,
        noOcrDetails: payload
      }
    },
    clearIdDetails() {
      return { ...initialState }
    }

  },
  effects: dispatch => {
    return {
      async uploadFront({ ...params }, state) {
        dispatch.apiStatus.setProcessing(true);
        this.clearIdDetails();
        fetchApi({
          method: 'post',
          url: hnAPI.ocr,
          data: params.data,
        })
          .then(data => {
            const { data: {
              dob = '',
              firstName = '',
              firstLastName = '',
              idNumber = '',
              lastName = '',
              secondLastName = '',
              gender = '',
              fileName = '',
              idVersion = ''
            } = {} } = data;
            if (!fileName) {
              dispatch.apiStatus.setRequestFailed({ message: 'Error de servidor interno' });
              return;
            }
            const formattedDob = dob ? dob.split('-') : ['', '', ''];
            const [birthDate, birthMonth, birthYear] = formattedDob;
            const cliFirstName = firstName + " " + lastName;
            const cliLastName = firstLastName + " " + secondLastName;
            const formattedBirthMonth = birthMonth ? getMonth(birthMonth, idVersion) : {};
            const formattedFileName = fileName.substring(0, fileName.lastIndexOf('/'))
            let idDetails = {
              birthDate,
              birthMonth: formattedBirthMonth ? formattedBirthMonth.short : '',
              birthYear,
              cliFirstName,
              cliLastName,
              documentNumber: idNumber,
              ocrSuccess: idNumber ? true : false,
            }
            if (!isDisabled(idDetails)) {
              idDetails = { ...idDetails, gender: autoCapitalize(gender) };
              this.updateOCRError(false);
              dispatch.activation.updateClientInformation({ ...idDetails, folderName: formattedFileName + '/' });
              dispatch.apiStatus.setProcessing(false);
              params.callback && params.callback();
              updateGlobalTracker({ photo_capture_front: true,  manual_input: false})
              track(PHOTO_CAPTURE_COMPLETED, { journey: ACTIVATION, capture_element: CAPTURE_ELEMENT_FRNTID})
            }
            else {
              idDetails = { ...idDetails, gender: autoCapitalize(gender) };
              this.updateOCRError(true);
              dispatch.activation.updateClientInformation({ ...idDetails, folderName: formattedFileName + '/' });
              params.callback && params.callback();
              updateGlobalTracker({ photo_capture_front: false})
              track(PHOTO_CAPTURE_FAILED, { journey: ACTIVATION, capture_element: CAPTURE_ELEMENT_FRNTID, error_type: 'error', error_id: 200, error_message: texts.OCR_ERROR_TEXT});
              updateGlobalTracker({ manual_input: true})
            }
          })
          .catch(error => {
            this.updateOCRError(true);
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(PHOTO_CAPTURE_FAILED, { journey: ACTIVATION, capture_element: CAPTURE_ELEMENT_FRNTID, error_type: 'error', error_id: error.errorCode, error_message: error.message});
            track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'ID Scanning Front', hnAPI.ocr, 'ID Front Upload API' )})
            track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'ID Front Upload API')})
          });
      },

      async noOcrUploadFront({ ...params }, state) {
        dispatch.apiStatus.setProcessing(true);
        this.clearIdDetails();
        fetchApi({
          method: 'post',
          url: hnAPI.upload,
          data: params.data,
        })
          .then(response => {
            const {
              data: {
                Payload: { fileName, imageUrl }
              }
            } = response;
            const uploadDetails = {
              fileName: fileName && fileName.substring(0, fileName.lastIndexOf('/')),
              imageUrl,
            };
            this.updateUploadDetails(uploadDetails);
            dispatch.apiStatus.setProcessing(false);
            params.callback && params.callback();
          })
          .catch(error => {
            track(PHOTO_CAPTURE_FAILED, { journey: ACTIVATION, capture_element: CAPTURE_ELEMENT_FRNTID, error_type: 'error', error_id: error.errorCode, error_message: error.message});
            track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'ID Scanning Front', hnAPI.upload, 'ID Front Upload API' )})
            track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'ID Front Upload API')})
          });
      },

      async validateId(params) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'post',
          url: hnAPI.idValidation.replace('{}', params.document_id),
          data: {
            input_data: {
              birth_date: params.birth_date,
              document_id: params.document_id,
              email: ''
            },
            recipes: [
              "validate-information-detail"
            ]
          }
        })
          .then(response => {
            const { eligibility_decisions = [] } = response.data;
            const status = eligibility_decisions.find(decision => decision.status === 'accepted');
            if (status) {
              params.callback(pageURL_HN.contractInfo)
              updateGlobalTracker({ id_validation: 'yes'})
              return
            }
            params.callback(pageURL_HN.idNotValid);
            track(INELIGIBILITY_NOTIFIED, { journey: ACTIVATION })
          })
          .catch((error) => {
              dispatch.apiStatus.setRequestFailed({ ...error });
              track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'ID Review', hnAPI.idValidation.replace('{}', params.document_id), 'ID Validation API' )})
              track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'ID Validation API')})
          });
      }
    };
  },
};

function getMonth(birthMonth, idVersion) {
  if (idVersion === 'v1') {
    return config.months.find((month) => month.label.toLowerCase() === birthMonth.toLowerCase());
  }
  else if (idVersion === 'v2')  {
    return config.months.find((month) => month.value === birthMonth);
  }
  return {}
}
